export default (props) => (
  <svg {...props} viewBox="0 0 30 30" aria-hidden="true" focusable="false">
    <g fill="none" fillRule="evenodd">
      <path d="m0 0h30v30h-30z" />
      <path
        d="m12.9521382 8.15472796s.0491333-2.00174977 0-2.66792348c-.0178666-.24968062-.1004999-.68124065-.3740832-.9352261-.4890998-.45416044-1.2685328-.43801729-1.7386493.0344387l-6.49118089 6.51752502c-.66329975.6661738-.66329975 1.7090208 0 2.3751945l6.49118089 6.5186013c.2423166.2421471.5639164.364835.886633.364835.3059665 0 .6130498-.1097733.8520163-.3303963.2367333-.2195467.3495166-.5843818.3740832-.8039285.0737-.6306588 0-2.5409308 0-2.5409308 5.0037815.4369411 9.2180799 3.8614399 10.4542294 8.6268958l.0122833.0419722c.2367333.7748708.839733.8652724 1.1077329.8652724.0625333 0 .1060833-.005381.12395-.0075334.9860163-.1291452 1.1322996-.6887741 1.2004162-4.6212438 0-7.0803827-5.6927645-12.90052397-12.8986118-13.43755254z"
        stroke="currentColor"
        strokeWidth="1.7"
        transform="matrix(-1 0 0 1 29.7015 0)"
      />
    </g>
  </svg>
);
